import { expVal } from '@confluence/feature-experiments';
import {
	SIMPLIFY_NAV_NEW_USER,
	ONBOARDING_EXPERIENCES,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

import { isWithinD0Window, isWithinD0WindowEpoch } from './isWithinD0Window.ts';
import { preloadSpaceBlogCount } from './preloadSpaceBlogCount.ts';

export type OnboardingStateResult = {
	data: { onboardingState?: Array<{ key: string; value?: string | null }> | null } | null;
	hasErrors: boolean;
};

/**
 * Runs simplify-nav preload for space nav when the user is eligible (e.g. D0).
 * Currently preloads space blog count; call with the result of preloadSideNavigationOnboardingState().
 */
export async function preloadSimplifiedNavForSpaceNav(
	spaceKey: string,
	result: OnboardingStateResult,
): Promise<void> {
	const { data, hasErrors } = result;

	if (hasErrors || !data?.onboardingState) {
		return;
	}

	const eligibleEntry = data.onboardingState.find(
		(s) => s.key === SIMPLIFY_NAV_NEW_USER.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
	);
	const startAtEntry = data.onboardingState.find(
		(s) => s.key === SIMPLIFY_NAV_NEW_USER.NTH_USER_D0_SIMPLIFIED_NAV_START_AT,
	);

	if (eligibleEntry?.value !== 'true') {
		return;
	}

	// Relevant for real experiment variant users
	if (startAtEntry?.value) {
		if (isWithinD0Window(startAtEntry.value)) {
			await preloadSpaceBlogCount(spaceKey);
		}
		return;
	}

	// TODO: Remove A/A fallback when cc_activation_simplify_nav_new_user_aa is cleaned up.
	if (expVal('cc_activation_simplify_nav_new_user_aa', 'cohort', 'control') !== 'control') {
		const completedEntry = data.onboardingState.find(
			(s) => s.key === ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
		);

		if (completedEntry?.value) {
			if (isWithinD0WindowEpoch(Number(completedEntry.value))) {
				await preloadSpaceBlogCount(spaceKey);
			}
		}
	}
}
